import styled from "styled-components";

const DefaultWidgetWidth    = '320px';
const DefaultWidgetHeight   = '320px';
const DefaultWidgetBgColor  = '#BDC7C9';
const DefaultWidgetColorMode     = {
    default: '#002b70',
    primary: '#193498',
    success: '#7ECA9C',
    warning: 'orange',
    danger: '#FA4659',
    active: '#1597BB',
    inactive: '#BBBBBB'
}
const DefaultMaxScreenSize      = '600px';
export const PageLogin = styled.div`
    display: grid;
    height: 100vh;
    place-items: center;
    background-color: ${(DefaultWidgetBgColor)};
`;

export const WidgetContainer = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;

    background-color: white;
    width: ${(DefaultWidgetWidth)};
    min-height: ${(DefaultWidgetHeight)};

    padding-top: 5px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 10px;

    border-radius: 10px;
    box-shadow: 0px 4px 20px -2px ${({Mode}) => (
        typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
        `${DefaultWidgetColorMode.default}`
        :`${Mode}`.trim().toLowerCase() === 'primary'?
        `${DefaultWidgetColorMode.primary}`
        :`${Mode}`.trim().toLowerCase() === 'success'?
        `${DefaultWidgetColorMode.success}`
        :`${Mode}`.trim().toLowerCase() === 'warning'?
        `${DefaultWidgetColorMode.warning}`
        :`${Mode}`.trim().toLowerCase() === 'danger'?
        `${DefaultWidgetColorMode.danger}`
        :`${Mode}`.trim().toLowerCase() === 'active'?
        `${DefaultWidgetColorMode.active}`
        :`${Mode}`.trim().toLowerCase() === 'inactive'?
        `${DefaultWidgetColorMode.inactive}`
        :`${DefaultWidgetColorMode.default}`
    )};
    border: solid 0.4px ${({Mode}) => (
        typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
        `${DefaultWidgetColorMode.default}`
        :`${Mode}`.trim().toLowerCase() === 'primary'?
        `${DefaultWidgetColorMode.primary}`
        :`${Mode}`.trim().toLowerCase() === 'success'?
        `${DefaultWidgetColorMode.success}`
        :`${Mode}`.trim().toLowerCase() === 'warning'?
        `${DefaultWidgetColorMode.warning}`
        :`${Mode}`.trim().toLowerCase() === 'danger'?
        `${DefaultWidgetColorMode.danger}`
        :`${Mode}`.trim().toLowerCase() === 'active'?
        `${DefaultWidgetColorMode.active}`
        :`${Mode}`.trim().toLowerCase() === 'inactive'?
        `${DefaultWidgetColorMode.inactive}`
        :`${DefaultWidgetColorMode.default}`
    )};

    overflow: hidden;

    @media only screen and (max-width: 600px) {
        width: 85%;

        transition: 0.3s ease-in-out;
    }
`;

export const WidgetMain = styled.div`
    width: 100%;
    padding-left: 5px;
    padding-right: 5px;
`;

export const WidgetHeader = styled.div`
    margin-top: 3mm;
    width: 100%;
    background-color: transparent;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin-bottom: 1mm;
    border-bottom: solid 1px lightgrey;
`;
    export const LogoContainer = styled.div`
        display: flexbox;
        align-items: center;
        /* width: 55px; */
        /* height: 55px; */
        width: 80%;
        height: 50px;

        /* border-radius: 50%; */
        overflow: hidden;
        background-color: white;

        //border: solid 0.5px lightgrey;
        //border: solid 2px dimgrey;
        border: solid 2px transparent;
    `;
    export const LogoImage = styled.img`
        //width: 50px;
        //height: 45px;
        
        /* width: 50px;
        height: 50px; */
        /* border-radius: 50%; */
        display: block;

        width: 90%;

        margin-left: auto;
        margin-right: auto;

        background-color: transparent;
    `;
    export const TitleContainer = styled.div`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        margin-top: 1mm;
        padding-left: 3px;
        padding-right: 3px;
        padding-bottom: 3px;
    `;
    export const HeaderTitle = styled.div`
        font-size: 14px;
        font-weight: bold;
        color: #002b70;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select:none;
    `;

export const WidgetBody     = styled.div`
    width: 100%;
    background-color: transparent;
    margin-top: 4mm;    
`;

export const WidgetFooter   = styled.div`
    width: 100%;
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: '5px'
    )};
    //height: max-content;
    min-height: 45px;
    
    display: flex;    
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    bottom: 1mm;
    background-color: transparent;
`;
    export const LoginMessage = styled.div`
        width: 100%;
        //color: #FF4646;
        color: red;
        //font-size: 0.7em;
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            '0.7em':`${FontSize}`
        )};
        display: flexbox;
        background-color: transparent;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select:none;

        @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
            font-size: 0.75em;
            transition: 0.3s ease-in-out;
        }
    `;
    export const FooterText = styled.div`
        width: 100%;
        display: flexbox;
        color: #002b70;
        font-size: 0.6em;
        background-color: transparent;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select:none;
    `;